<template>
  <v-tooltip right open-delay="500" :color="tooltipColor">
    <template v-slot:activator="{ props }">
      <v-btn
        variant="flat"
        color="primary"
        @click.stop="!isLinked(item) ? setDone(): null"
        v-bind="props"

      >
        <div v-if="isLinked(item)">
          Linked
        </div>
        <div v-else>
          Done

        </div>
        <template #append>
          <v-icon v-if="isLinked(item)" size="21">
            mdi-link-variant
          </v-icon>
          <v-icon v-else-if="item.done" size="21">
            mdi-check-circle-outline
          </v-icon>
          <v-avatar v-else color="white" size="21">
            {{ item.stage_configuration.number }}
          </v-avatar>
        </template>


      </v-btn>
    </template>
    <div class="d-flex flex-row justify-space-between align-center">
      <v-icon v-if="hasPreviousUndoneStage" dense color="white" class="mr-1">mdi-information-outline</v-icon>
      <span class="d-block">{{ tooltipText }}</span>
    </div>
  </v-tooltip>

</template>
<script>
  import { mapActions, mapGetters, mapState } from "vuex"

  export default {
    name: "SchematisationStageDoneButton",
    props: {
      item: {}
    },
    computed: {
      ...mapGetters("stabSchematisation", {
        isLinked: "isLinked"
      }),
      ...mapState("stabSchematisation", {
        stabSchematisation: (state) => state.currentItem,
        currentOverViewItem: (state) => state.currentOverviewItem
      }),
      ...mapState("stabSchematisationStage", {
        currentStabSchematisationStage: state => state.currentItem,
        stabSchematisationStageItems: state => state.items,
        loading: state => state.loading
      }),
      tooltipText () {
        if (this.isLinked(this.item)) {
          return "This stage is \"linked\", you can not make change to this stage. Go to the base schematisation to make changes in this stage."
        } else if (this.item.done) {
          return "This stage is marked as \"done\", you can toggle this state by pressing this button. When a stage is done it cannot be changed."
        }
        if (this.canSetDone) {
          return "This stage can be marked as \"done\". Done stages can be used to be a base schematisation stage for a linked schematisation and generating reinforcements."
        } else if (this.hasPreviousUndoneStage) {
          return "You cannot mark this stage as \"done\" because the previous stage is not done."
        } else {
          return "Error"
        }
      },
      itemIndex () {
        return this.stabSchematisationStageItems.indexOf(this.item)
      },
      hasPreviousUndoneStage () {
        return this.itemIndex > 0 && !this.stabSchematisationStageItems[this.itemIndex - 1].done
      },
      tooltipColor () {
        return this.hasPreviousUndoneStage ? "warning" : null
      },
      canSetDone () {
        const index = this.itemIndex
        return (index === 0 || this.stabSchematisationStageItems[index - 1].done || this.isLinked(this.stabSchematisationStageItems[index - 1]))
      }
    },
    methods: {
      ...mapActions("stabSchematisationStage", {
        setCurrentStabSchematisationStage: "setCurrentItem",
        setParameter: "setParameter",
        updateItem: "updateItem",
        fetchStabSchematisationStageItems: "fetchItems"
      }),
      ...mapActions("stabSchematisation", {
        fetchItemAndReplaceSchematisation: "fetchItemAndReplace"
      }),
      ...mapActions("dikeProfiles", {
        setSelectedStabSchematisationStageId: "setSelectedStabSchematisationStageId"
      }),
      ...mapActions("overview", {
        cleanSchematisationStageRelatedData: "cleanSchematisationStageRelatedData",
        fetchOverviewData: "fetchOverviewData",
        toggleOverviewLoading: "toggleLoading"
      }),
      async setDone () {
        const index = this.itemIndex
        if (this.canSetDone) {
          if (!this.stabSchematisationStageItems[index + 1] || !this.stabSchematisationStageItems[index + 1].done) {
            try {
              this.setParameter({
                value: !this.item.done,
                item: this.item,
                parameter: "done"
              })
              await this.updateItem(this.item)
              await this.fetchItemAndReplaceSchematisation(this.item.stab_schematisation)
              await this.cleanSchematisationStageRelatedData(this.item)
              this.toggleOverviewLoading(true)
              if (this.currentOverViewItem?.id === this.stabSchematisation?.id) {
                const previousStage = this.stabSchematisationStageItems[index - 1]
                const previousStageId = previousStage ? previousStage.id : null
                const selectedStabSchematisationStageId = this.item.done ? this.item.id : previousStageId
                this.setSelectedStabSchematisationStageId(selectedStabSchematisationStageId)
              }
              this.toggleOverviewLoading(false)
            } catch (e) {
              this.setParameter({
                value: !this.item.done,
                item: this.item,
                parameter: "done"
              })
              console.log(e)
            }
          }
        }
      }
    }
  }
</script>
